export default {
  notification: {}
};
